<template lang="html">
  <Row>
    <Hero
      :slant="true"
      :isMobile="isMobile"
      :title="content.title"
      :description="content.description"
      :backgroundColor="content.backgroundColor"
      :image="content.image"
      :textShadow="false">
    </Hero>
    <ContentImageSection
      :windowWidth="windowWidth"
      :title="content.problem.title"
      :descriptions="content.problem.descriptions"
      :image="content.problem.image"
      type="img-right">
    </ContentImageSection>
    <ContentImageSection
      :windowWidth="windowWidth"
      :title="content.solution.title"
      :descriptions="content.solution.descriptions"
      :image="content.solution.image"
      :type="!isMobile? 'img-left' : 'img-right'"
      imageWidth="450px">
    </ContentImageSection>
    <DemonstrationSection
      v-if="content.demo"
      :windowWidth="windowWidth"
      :isMobile="isMobile"
      :title="content.demo.title"
      :sections="content.demo.sections">
    </DemonstrationSection>
    <SectionNavigation :current="content.id"></SectionNavigation>
    <EmailSignupSection :isMobile="isMobile"></EmailSignupSection>
    <AggressiveCTA :isMobile="isMobile"></AggressiveCTA>
  </Row>
</template>
<script>
import pages from '../services/pages';
import Hero from './Hero';
import SectionNavigation from './SectionNavigation';
import ContentImageSection from './ContentImageSection';
import DemonstrationSection from './DemonstrationSection';
import EmailSignupSection from './EmailSignupSection';
import AggressiveCTA from './AggressiveCTA';

export default {
  components: { AggressiveCTA, Hero, SectionNavigation, ContentImageSection, DemonstrationSection, EmailSignupSection },
  props: ['windowWidth', 'isMobile'],
  data() {
    const content = pages.aggregation;
    return { content };
  },
};
</script>
<style lang="css">

</style>


// WEBPACK FOOTER //
// src/components/AggregationPage.vue